import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {ToggleShowOddsHandler} from "../../../core/handlers/toggle-show-odds.handler";
import {FilterBarModuleFetchHandler} from "./filter-bar-module.fetch-handler";
import {FilterBarModuleToggleClickHandler} from "./filter-bar-module.toggle-click.handler";

export class FilterBarModuleHandlers extends HandlerList {
  static injectables = [
    FilterBarModuleFetchHandler,
    FilterBarModuleToggleClickHandler,
    ToggleShowOddsHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    filterBarModuleFetchHandler: FilterBarModuleFetchHandler,
    filterBarModuleToggleClickHandler: FilterBarModuleToggleClickHandler,
    toggleShowOddsHandler: ToggleShowOddsHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();
    [
      filterBarModuleFetchHandler,
      filterBarModuleToggleClickHandler,
      toggleShowOddsHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
